import { faSync } from "@fortawesome/pro-solid-svg-icons/faSync";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from "react";

export const MprcSyncIndicator: React.FC<{}> = () => (
    <FontAwesomeIcon
        fixedWidth
        spin={true}
        icon={faSync}
        style={{ fontSize: "0.775em" }}
    />
);
